import loadingPlugin from '@rematch/loading';
import {init} from '@rematch/core';

import {models, RootModel} from './models';
import {trackLoadingWhitelist} from './constants';
import {FullModel} from './types';

export const store = init<RootModel, FullModel>({
  models,
  plugins: [
    loadingPlugin({
      whitelist: trackLoadingWhitelist,
      type: 'full',
    }),
  ],
});

export type Store = typeof store;
